/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HibernationJob } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * HibernationJobsAPIApi - axios parameter creator
 * @export
 */
export const HibernationJobsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create cluster hibernation job
         * @summary Create cluster hibernation job. 
         * @param {string} organizationId ID of the cluster that the hibernation job is for
         * @param {string} clusterId ID of the cluster that the hibernation job is for
         * @param {HibernationJob} hibernationJob 
         * @param {HibernationJobsAPICreateHibernationJobModeEnum} [mode] Mode of the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPICreateHibernationJob: async (organizationId: string, clusterId: string, hibernationJob: HibernationJob, mode?: HibernationJobsAPICreateHibernationJobModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationJobsAPICreateHibernationJob', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('hibernationJobsAPICreateHibernationJob', 'clusterId', clusterId)
            // verify required parameter 'hibernationJob' is not null or undefined
            assertParamExists('hibernationJobsAPICreateHibernationJob', 'hibernationJob', hibernationJob)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/hibernation-jobs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hibernationJob, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a cluster hibernation job by ID
         * @summary Get cluster hibernation job by ID.
         * @param {string} organizationId ID of the organization that the hibernation job belongs to
         * @param {string} clusterId ID of the cluster that the hibernation job belongs to
         * @param {string} id ID of the hibernation job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPIGetHibernationJob: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationJobsAPIGetHibernationJob', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('hibernationJobsAPIGetHibernationJob', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hibernationJobsAPIGetHibernationJob', 'id', id)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/hibernation-jobs/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires an existing hibernation schedule, that is assigned to the cluster being resumed.
         * @summary Initiate manual cluster pause through a hibernation job.
         * @param {string} organizationId ID of the cluster that the hibernation job is for
         * @param {string} clusterId ID of the cluster that the hibernation job is for
         * @param {HibernationJobsAPIPauseClusterModeEnum} [mode] Mode of the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPIPauseCluster: async (organizationId: string, clusterId: string, mode?: HibernationJobsAPIPauseClusterModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationJobsAPIPauseCluster', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('hibernationJobsAPIPauseCluster', 'clusterId', clusterId)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/hibernation-jobs:pauseCluster`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires an existing hibernation schedule, that is assigned to the cluster being resumed. The schedule\'s node configuration is used as the base for the resume node.
         * @summary Initiate manual cluster resume through a hibernation job.
         * @param {string} organizationId ID of the cluster that the hibernation job is for
         * @param {string} clusterId ID of the cluster that the hibernation job is for
         * @param {HibernationJobsAPIResumeClusterModeEnum} [mode] Mode of the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPIResumeCluster: async (organizationId: string, clusterId: string, mode?: HibernationJobsAPIResumeClusterModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationJobsAPIResumeCluster', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('hibernationJobsAPIResumeCluster', 'clusterId', clusterId)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/hibernation-jobs:resumeCluster`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HibernationJobsAPIApi - functional programming interface
 * @export
 */
export const HibernationJobsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HibernationJobsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Create cluster hibernation job
         * @summary Create cluster hibernation job. 
         * @param {string} organizationId ID of the cluster that the hibernation job is for
         * @param {string} clusterId ID of the cluster that the hibernation job is for
         * @param {HibernationJob} hibernationJob 
         * @param {HibernationJobsAPICreateHibernationJobModeEnum} [mode] Mode of the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationJobsAPICreateHibernationJob(organizationId: string, clusterId: string, hibernationJob: HibernationJob, mode?: HibernationJobsAPICreateHibernationJobModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationJobsAPICreateHibernationJob(organizationId, clusterId, hibernationJob, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationJobsAPIApi.hibernationJobsAPICreateHibernationJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a cluster hibernation job by ID
         * @summary Get cluster hibernation job by ID.
         * @param {string} organizationId ID of the organization that the hibernation job belongs to
         * @param {string} clusterId ID of the cluster that the hibernation job belongs to
         * @param {string} id ID of the hibernation job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationJobsAPIGetHibernationJob(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationJobsAPIGetHibernationJob(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationJobsAPIApi.hibernationJobsAPIGetHibernationJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires an existing hibernation schedule, that is assigned to the cluster being resumed.
         * @summary Initiate manual cluster pause through a hibernation job.
         * @param {string} organizationId ID of the cluster that the hibernation job is for
         * @param {string} clusterId ID of the cluster that the hibernation job is for
         * @param {HibernationJobsAPIPauseClusterModeEnum} [mode] Mode of the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationJobsAPIPauseCluster(organizationId: string, clusterId: string, mode?: HibernationJobsAPIPauseClusterModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationJobsAPIPauseCluster(organizationId, clusterId, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationJobsAPIApi.hibernationJobsAPIPauseCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires an existing hibernation schedule, that is assigned to the cluster being resumed. The schedule\'s node configuration is used as the base for the resume node.
         * @summary Initiate manual cluster resume through a hibernation job.
         * @param {string} organizationId ID of the cluster that the hibernation job is for
         * @param {string} clusterId ID of the cluster that the hibernation job is for
         * @param {HibernationJobsAPIResumeClusterModeEnum} [mode] Mode of the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationJobsAPIResumeCluster(organizationId: string, clusterId: string, mode?: HibernationJobsAPIResumeClusterModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationJobsAPIResumeCluster(organizationId, clusterId, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationJobsAPIApi.hibernationJobsAPIResumeCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HibernationJobsAPIApi - factory interface
 * @export
 */
export const HibernationJobsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HibernationJobsAPIApiFp(configuration)
    return {
        /**
         * Create cluster hibernation job
         * @summary Create cluster hibernation job. 
         * @param {HibernationJobsAPIApiHibernationJobsAPICreateHibernationJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPICreateHibernationJob(requestParameters: HibernationJobsAPIApiHibernationJobsAPICreateHibernationJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationJob> {
            return localVarFp.hibernationJobsAPICreateHibernationJob(requestParameters.organizationId, requestParameters.clusterId, requestParameters.hibernationJob, requestParameters.mode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a cluster hibernation job by ID
         * @summary Get cluster hibernation job by ID.
         * @param {HibernationJobsAPIApiHibernationJobsAPIGetHibernationJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPIGetHibernationJob(requestParameters: HibernationJobsAPIApiHibernationJobsAPIGetHibernationJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationJob> {
            return localVarFp.hibernationJobsAPIGetHibernationJob(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires an existing hibernation schedule, that is assigned to the cluster being resumed.
         * @summary Initiate manual cluster pause through a hibernation job.
         * @param {HibernationJobsAPIApiHibernationJobsAPIPauseClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPIPauseCluster(requestParameters: HibernationJobsAPIApiHibernationJobsAPIPauseClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationJob> {
            return localVarFp.hibernationJobsAPIPauseCluster(requestParameters.organizationId, requestParameters.clusterId, requestParameters.mode, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires an existing hibernation schedule, that is assigned to the cluster being resumed. The schedule\'s node configuration is used as the base for the resume node.
         * @summary Initiate manual cluster resume through a hibernation job.
         * @param {HibernationJobsAPIApiHibernationJobsAPIResumeClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationJobsAPIResumeCluster(requestParameters: HibernationJobsAPIApiHibernationJobsAPIResumeClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationJob> {
            return localVarFp.hibernationJobsAPIResumeCluster(requestParameters.organizationId, requestParameters.clusterId, requestParameters.mode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for hibernationJobsAPICreateHibernationJob operation in HibernationJobsAPIApi.
 * @export
 * @interface HibernationJobsAPIApiHibernationJobsAPICreateHibernationJobRequest
 */
export interface HibernationJobsAPIApiHibernationJobsAPICreateHibernationJobRequest {
    /**
     * ID of the cluster that the hibernation job is for
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPICreateHibernationJob
     */
    readonly organizationId: string

    /**
     * ID of the cluster that the hibernation job is for
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPICreateHibernationJob
     */
    readonly clusterId: string

    /**
     * 
     * @type {HibernationJob}
     * @memberof HibernationJobsAPIApiHibernationJobsAPICreateHibernationJob
     */
    readonly hibernationJob: HibernationJob

    /**
     * Mode of the operation.
     * @type {'OPERATION_MODE_UNSPECIFIED' | 'OPERATION_MODE_DEFAULT' | 'OPERATION_MODE_DRY_RUN'}
     * @memberof HibernationJobsAPIApiHibernationJobsAPICreateHibernationJob
     */
    readonly mode?: HibernationJobsAPICreateHibernationJobModeEnum
}

/**
 * Request parameters for hibernationJobsAPIGetHibernationJob operation in HibernationJobsAPIApi.
 * @export
 * @interface HibernationJobsAPIApiHibernationJobsAPIGetHibernationJobRequest
 */
export interface HibernationJobsAPIApiHibernationJobsAPIGetHibernationJobRequest {
    /**
     * ID of the organization that the hibernation job belongs to
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIGetHibernationJob
     */
    readonly organizationId: string

    /**
     * ID of the cluster that the hibernation job belongs to
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIGetHibernationJob
     */
    readonly clusterId: string

    /**
     * ID of the hibernation job
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIGetHibernationJob
     */
    readonly id: string
}

/**
 * Request parameters for hibernationJobsAPIPauseCluster operation in HibernationJobsAPIApi.
 * @export
 * @interface HibernationJobsAPIApiHibernationJobsAPIPauseClusterRequest
 */
export interface HibernationJobsAPIApiHibernationJobsAPIPauseClusterRequest {
    /**
     * ID of the cluster that the hibernation job is for
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIPauseCluster
     */
    readonly organizationId: string

    /**
     * ID of the cluster that the hibernation job is for
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIPauseCluster
     */
    readonly clusterId: string

    /**
     * Mode of the operation.
     * @type {'OPERATION_MODE_UNSPECIFIED' | 'OPERATION_MODE_DEFAULT' | 'OPERATION_MODE_DRY_RUN'}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIPauseCluster
     */
    readonly mode?: HibernationJobsAPIPauseClusterModeEnum
}

/**
 * Request parameters for hibernationJobsAPIResumeCluster operation in HibernationJobsAPIApi.
 * @export
 * @interface HibernationJobsAPIApiHibernationJobsAPIResumeClusterRequest
 */
export interface HibernationJobsAPIApiHibernationJobsAPIResumeClusterRequest {
    /**
     * ID of the cluster that the hibernation job is for
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIResumeCluster
     */
    readonly organizationId: string

    /**
     * ID of the cluster that the hibernation job is for
     * @type {string}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIResumeCluster
     */
    readonly clusterId: string

    /**
     * Mode of the operation.
     * @type {'OPERATION_MODE_UNSPECIFIED' | 'OPERATION_MODE_DEFAULT' | 'OPERATION_MODE_DRY_RUN'}
     * @memberof HibernationJobsAPIApiHibernationJobsAPIResumeCluster
     */
    readonly mode?: HibernationJobsAPIResumeClusterModeEnum
}

/**
 * HibernationJobsAPIApi - object-oriented interface
 * @export
 * @class HibernationJobsAPIApi
 * @extends {BaseAPI}
 */
export class HibernationJobsAPIApi extends BaseAPI {
    /**
     * Create cluster hibernation job
     * @summary Create cluster hibernation job. 
     * @param {HibernationJobsAPIApiHibernationJobsAPICreateHibernationJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationJobsAPIApi
     */
    public hibernationJobsAPICreateHibernationJob(requestParameters: HibernationJobsAPIApiHibernationJobsAPICreateHibernationJobRequest, options?: RawAxiosRequestConfig) {
        return HibernationJobsAPIApiFp(this.configuration).hibernationJobsAPICreateHibernationJob(requestParameters.organizationId, requestParameters.clusterId, requestParameters.hibernationJob, requestParameters.mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a cluster hibernation job by ID
     * @summary Get cluster hibernation job by ID.
     * @param {HibernationJobsAPIApiHibernationJobsAPIGetHibernationJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationJobsAPIApi
     */
    public hibernationJobsAPIGetHibernationJob(requestParameters: HibernationJobsAPIApiHibernationJobsAPIGetHibernationJobRequest, options?: RawAxiosRequestConfig) {
        return HibernationJobsAPIApiFp(this.configuration).hibernationJobsAPIGetHibernationJob(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires an existing hibernation schedule, that is assigned to the cluster being resumed.
     * @summary Initiate manual cluster pause through a hibernation job.
     * @param {HibernationJobsAPIApiHibernationJobsAPIPauseClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationJobsAPIApi
     */
    public hibernationJobsAPIPauseCluster(requestParameters: HibernationJobsAPIApiHibernationJobsAPIPauseClusterRequest, options?: RawAxiosRequestConfig) {
        return HibernationJobsAPIApiFp(this.configuration).hibernationJobsAPIPauseCluster(requestParameters.organizationId, requestParameters.clusterId, requestParameters.mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires an existing hibernation schedule, that is assigned to the cluster being resumed. The schedule\'s node configuration is used as the base for the resume node.
     * @summary Initiate manual cluster resume through a hibernation job.
     * @param {HibernationJobsAPIApiHibernationJobsAPIResumeClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationJobsAPIApi
     */
    public hibernationJobsAPIResumeCluster(requestParameters: HibernationJobsAPIApiHibernationJobsAPIResumeClusterRequest, options?: RawAxiosRequestConfig) {
        return HibernationJobsAPIApiFp(this.configuration).hibernationJobsAPIResumeCluster(requestParameters.organizationId, requestParameters.clusterId, requestParameters.mode, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const HibernationJobsAPICreateHibernationJobModeEnum = {
    UNSPECIFIED: 'OPERATION_MODE_UNSPECIFIED',
    DEFAULT: 'OPERATION_MODE_DEFAULT',
    DRY_RUN: 'OPERATION_MODE_DRY_RUN'
} as const;
export type HibernationJobsAPICreateHibernationJobModeEnum = typeof HibernationJobsAPICreateHibernationJobModeEnum[keyof typeof HibernationJobsAPICreateHibernationJobModeEnum];
/**
 * @export
 */
export const HibernationJobsAPIPauseClusterModeEnum = {
    UNSPECIFIED: 'OPERATION_MODE_UNSPECIFIED',
    DEFAULT: 'OPERATION_MODE_DEFAULT',
    DRY_RUN: 'OPERATION_MODE_DRY_RUN'
} as const;
export type HibernationJobsAPIPauseClusterModeEnum = typeof HibernationJobsAPIPauseClusterModeEnum[keyof typeof HibernationJobsAPIPauseClusterModeEnum];
/**
 * @export
 */
export const HibernationJobsAPIResumeClusterModeEnum = {
    UNSPECIFIED: 'OPERATION_MODE_UNSPECIFIED',
    DEFAULT: 'OPERATION_MODE_DEFAULT',
    DRY_RUN: 'OPERATION_MODE_DRY_RUN'
} as const;
export type HibernationJobsAPIResumeClusterModeEnum = typeof HibernationJobsAPIResumeClusterModeEnum[keyof typeof HibernationJobsAPIResumeClusterModeEnum];
